/**
 * Zapier's OneTrust domain script ID.
 * @see https://gitlab.com/zapier/design-systems/cookie-consent/-/tree/main/packages/cookie-consent#onetrust-cookie-consent-script
 */
const DOMAIN_SCRIPT_ID = "c2bc6bc2-2599-4efd-90da-5725af13c244";

/**
 * OneTrust configuration for Zapier's cookie consent.
 * All config values are static and should not be overridden by consumers.
 *
 * @see https://gitlab.com/zapier/design-systems/cookie-consent/-/tree/main/packages/cookie-consent#onetrust-cookie-consent-script
 */
export const ONETRUST_CONFIG = {
  scriptSrc: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
  domainScriptId: DOMAIN_SCRIPT_ID,
  testDomainScriptId: `${DOMAIN_SCRIPT_ID}-test`,
  elementId: "onetrust-cookie-consent-script",
} as const;
